import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
//
//
const ViewAllBtn = ({ text, link }) => {
  //
  //
  return (
    <div className="text-right inline-block relative group text-black font-medium py-1 cursor-pointer">
      <Link
        to={link || "/new-implements"}
        className="text-[14px] font-medium text-[#1550A1]"
      >
        {text}
        <span className="inline-block w-[20px] h-[15px] ml-2">
          <ArrowRightIcon />
        </span>
      </Link>
      <span class="inline-block absolute left-0 bottom-0 w-0 h-0.5 bg-[#1550A1] transition-all duration-300 group-hover:w-full"></span>
    </div>
  );
};
export default ViewAllBtn;
